document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const role = urlParams.get("role");

  // Update heading text
  if (role) {
    const roleTitleElement = document.getElementById("roleTitle");
    if (roleTitleElement) {
      roleTitleElement.textContent = role;
    }

    // Optional: Add hidden field to send role name to Google Sheet
    const form = document.querySelector("#careerForm"); // change ID if needed
    if (form) {
      let hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "Role";
      hiddenInput.value = role;
      form.appendChild(hiddenInput);
    }
  }
  
  const form = document.getElementById("jobForm");
  const successMsg = document.getElementById("successMsg");
  const resumeInput = document.getElementById("resumeInput");
  const uploadContent = document.querySelector(".upload-content");
  const submitBtn = form.querySelector(".form-submit");

  // Resume upload preview
  resumeInput.addEventListener("change", function () {
    const file = this.files[0];
    if (file) {
      uploadContent.innerHTML = `<p><strong>${file.name}</strong> uploaded successfully</p>`;
    } else {
      uploadContent.innerHTML = `<p><strong>Upload a file</strong> or drag and drop here</p>`;
    }
  });

  // Restrict phone input
  const phoneInput = document.getElementById("phone");
  phoneInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "").slice(0, 10);
  });

  // Submit form
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    // Required field check
    const requiredFields = form.querySelectorAll("input[required], textarea[required], select[required]");
    for (let field of requiredFields) {
      if (!field.value.trim()) {
        alert(`Please fill in the ${field.labels[0]?.innerText || field.name} field.`);
        field.focus();
        return;
      }
    }

    // Email validation
    const email = document.getElementById("email").value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      document.getElementById("email").focus();
      return;
    }

    // Phone validation (10 digits only)
    const phone = phoneInput.value.trim();
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      alert("Please enter a valid 10-digit phone number (numbers only).");
      phoneInput.focus();
      return;
    }

    // Submit to Google Sheet
    const formData = new FormData(form);
    formData.append("Timestamp", new Date().toISOString());

    const scriptURL = "https://script.google.com/macros/s/AKfycbzeYZafhj1Gbzh4zTi6S07t940oSIFRytc1d0FlVk8VRZ-bl10P5lFTC3r6EzCT35_P/exec";

    fetch(scriptURL, { method: "POST", body: formData })
      .then((response) => response.text())
      .then((text) => {
        if (text.includes("Success")) {
          alert("Thank you! Your application has been submitted successfully.");
          form.reset();
          resumeInput.value = "";
          uploadContent.innerHTML = `
            <img src="https://cdn.shopify.com/s/files/1/0941/5124/6136/files/Label.png?v=1762765707" alt="Upload Icon" class="upload-icon" />
            <p><strong>Upload a file</strong> or drag and drop here</p>
          `;
        } else {
          alert("Something went wrong: " + text);
        }
      })
      .catch((error) => alert("Error! " + error.message))
      .finally(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit";
      });
  });
  
});
